module.exports = __webpack_public_path__ + "static/img/label_bg@2x.5b64caaa.png";